import { createSelector } from 'reselect';
import { getIsAPMEnabled } from 'lib/selectors/getIsAPMEnabled';
import { getIsMESEnabled } from 'lib/selectors/getIsMESEnabled';

/**
 * Selector for APM ERP job flow (MES Palletized) — when true, the "current job"
 * is derived from the most recent program event or labor ticket (emitted by the
 * opdash display MFE), rather than from activity sets or the natsFlow labor
 * ticket subscription.
 *
 * Controlled by mesSettings: requires both mesEnabled (company + machine) and
 * apmEnabled (part operation fingerprint). Supersedes natsFlowEnabled when both
 * are on.
 */
const getIsApmERPJobFlow = createSelector(
  [getIsMESEnabled, getIsAPMEnabled],
  (mesEnabled, apmEnabled) => {
    return !!(mesEnabled && apmEnabled);
  }
);

export { getIsApmERPJobFlow };
